const tools
    = [
        {
            id: 1,
            name: 'JSON',
            src: ('../img/logos/json.png')
        }
        ,
        {
            id: 2,
            name: 'AJAX',
            src: ('../img/logos/ajax.png')
        },
        {
            id: 3,
            name: 'Rest API',
            src: ('../img/logos/restapi.png')
        },
        // {
        //     id: 4,
        //     name: 'Web Service',
        //     src: ('../img/logos/webservice.png')
        // },

        {
            id: 4,
            name: 'XML',
            src: ('../img/logos/xml.png')
        }
    ];
export default tools


